<template>
  <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
    <Divider orientation="left">申请人婚姻信息</Divider>
    <Row :gutter="16">
      <Col span="12" v-if="form.applicantMaritalStatus == $store.state.maritalStatusSet['初婚']||form.applicantMaritalStatus == $store.state.maritalStatusSet['再婚']">
      <FormItem label="上传持证人结婚证原件" prop="applicantMarriageCertificateGuid">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantMarriageCertificateGuidProgress')" :accept="accept" :format='format'
              :show-upload-list='false' :on-success="(response, file, fileList)=>{$refs['applicantMarriageCertificateGuidProgress'].updateShow(false)
        $refs['applicantMarriageCertificateGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantMarriageCertificateGuid')}" :on-format-error="handleFormatError"
              :action="$baseURL+'/common/file/uploadfile'">
              <div class="uploadBg">
                <span ref="applicantMarriageCertificateGuidProgressUpload">
                  <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                  <div class="upload_btn">
                    <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                  </div>
                  <div class="upload_btn" @click.stop="openQrCodeUpload('applicantMarriageCertificateGuid')">
                    <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                  </div>
                </span>
                <progress-bar ref="applicantMarriageCertificateGuidProgress"></progress-bar>

              </div>
            </Upload>
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantMarriageCertificateGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantMarriageCertificateGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantMarriageCertificateGuid)" type="ios-eye" />
                  <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,form.applicantMarriageCertificateGuid,'applicantMarriageCertificateGuid')" type="ios-trash-outline" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <template v-if="form.applicantMaritalStatus == $store.state.maritalStatusSet['离异']">
        <Col span="24">
        <Alert show-icon closable>离婚证与离婚协议、法院判决书、法院调解书必须上传一个</Alert>
        </Col>
        <Col span="24">
        <FormItem :label="'离婚证'" prop="applicantDivorceCertificateGuid">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'applicantDivorceCertificateGuidProgress')" :accept="accept" :format='format'
                :show-upload-list='false' :data="uploadData" :on-success="(response, file, fileList)=>{$refs['applicantDivorceCertificateGuidProgress'].updateShow(false)
        $refs['applicantDivorceCertificateGuidProgressUpload'].style.display = 'block';handleSuccess(response, file, fileList,'applicantDivorceCertificateGuid')}" :on-format-error="handleFormatError"
                :action="$baseURL+'/common/file/uploadfile'">
                <div class="uploadBg">
                  <span ref="applicantDivorceCertificateGuidProgressUpload">
                    <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                    <div class="upload_btn">
                      <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                    </div>
                    <div class="upload_btn" @click.stop="openQrCodeUpload('applicantDivorceCertificateGuid')">
                      <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                    </div>
                  </span>
                  <progress-bar ref="applicantDivorceCertificateGuidProgress"></progress-bar>

                </div>
              </Upload>
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantDivorceCertificateGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantDivorceCertificateGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantDivorceCertificateGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,'applicantDivorceCertificateGuid','applicantDivorceCertificateGuid')" type="ios-trash-outline" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem :label="'离婚协议'" prop="applicantDivorceSettlementGuidList">
          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.applicantDivorceSettlementGuidListPreview" :on-preview="handlePreview"
            :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemove(
                          file,
                          fileList,
                          `applicantDivorceSettlementGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccess(
                          response,
                          file,
                          fileList,
                          `applicantDivorceSettlementGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`applicantDivorceSettlementGuidList`,true)">手机拍照上传</Button>

          </Upload>
          <div class="_linkdel" v-for="file in form.applicantDivorceSettlementGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'applicantDivorceSettlementGuidList',true)" />
            </div>
          </div>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem :label="'法院判决材料'" prop="applicantMarriageCourtJudgmentGuidList">
          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.applicantMarriageCourtJudgmentGuidListPreview" :on-preview="handlePreview"
            :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemove(
                          file,
                          fileList,
                          `applicantMarriageCourtJudgmentGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccess(
                          response,
                          file,
                          fileList,
                          `applicantMarriageCourtJudgmentGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`applicantMarriageCourtJudgmentGuidList`,true)">手机拍照上传</Button>
          </Upload>
          <div class="_linkdel" v-for="file in form.applicantMarriageCourtJudgmentGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'applicantMarriageCourtJudgmentGuidList',true)" />
            </div>
          </div>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem :label="'法院调解书'" prop="applicantMarriageCourtMediationLetterGuidList">
          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.applicantMarriageCourtMediationLetterGuidListPreview" :on-preview="handlePreview"
            :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemove(
                          file,
                          fileList,
                          `applicantMarriageCourtMediationLetterGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccess(
                          response,
                          file,
                          fileList,
                          `applicantMarriageCourtMediationLetterGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`applicantMarriageCourtMediationLetterGuidList`,true)">手机拍照上传</Button>
          </Upload>
          <div class="_linkdel" v-for="file in form.applicantMarriageCourtMediationLetterGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'applicantMarriageCourtMediationLetterGuidList',true)" />
            </div>
          </div>
        </FormItem>
        </Col>
      </template>
      <template v-if="form.applicantMaritalStatus === $store.state.materiaBasicData.maritalStatusSet['丧偶']">
        <Col span="24">
        <FormItem :label="'死亡证明'" prop="applicantSpouseDeathCertificateGuidList" :rules="{
                  required: form.applicantMaritalStatus === $store.state.materiaBasicData.maritalStatusSet['丧偶'],
                  type:'array',
                  message: '请上传',
                  trigger: 'change',
                }">
          <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.applicantSpouseDeathCertificateGuidListPreview" :on-preview="handlePreview"
            :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemove(
                          file,
                          fileList,
                          `applicantSpouseDeathCertificateGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccess(
                          response,
                          file,
                          fileList,
                          `applicantSpouseDeathCertificateGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
            <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
            <Button icon="ios-camera" @click.stop="openQrCodeUpload(`applicantSpouseDeathCertificateGuidList`,true)">手机拍照上传</Button>

          </Upload>
          <div class="_linkdel" v-for="file in form.applicantSpouseDeathCertificateGuidListPreview" :key="file.guid">
            <div class="fileCentent" @click="handlePreview(file)">
              <Icon :type="file.name | fileType" />
              {{file.name?file.name:file.fileName}}
            </div>
            <div class="fileDel">
              <Icon type="md-close" @click="handleRemove(file, null, 'applicantSpouseDeathCertificateGuidList',true)" />
            </div>
          </div>
        </FormItem>
        </Col>
        <!-- <Col span="24">
              <FormItem :label="'户籍注销'" prop="domicileCancelGuidList" :rules="{
                  required: form.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['丧偶'],
                  message: '请上传',
                   type:'array',
                  trigger: 'change',
                }">
                <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="form.domicileCancelGuidListPreview" :on-preview="handlePreview"
                  :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemove(
                          file,
                          fileList,
                          `domicileCancelGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccess(
                          response,
                          file,
                          fileList,
                          `domicileCancelGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
                  <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                  <Button icon="ios-camera" @click.stop="openQrCodeUpload(`domicileCancelGuidList`,true)">手机拍照上传</Button>
                </Upload>
                <div class="_linkdel" v-for="file in form.domicileCancelGuidListPreview" :key="file.guid">
                  <div class="fileCentent" @click="handlePreview(file)">
                    <Icon :type="file.name | fileType" />
                    {{file.name?file.name:file.fileName}}
                  </div>
                  <div class="fileDel">
                    <Icon type="md-close" @click="handleRemove(file, null, 'domicileCancelGuidList',true)" />
                  </div>
                </div>
              </FormItem>
              </Col> -->
      </template>
      <Col span="24" v-if="form.applicantMaritalStatus != $store.state.maritalStatusSet['初婚']">
      <FormItem class="noticeTop" label="历史婚姻材料">
        <Upload ref="applicantHistoricalMarriageFileGuidList" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :show-upload-list="false" :default-file-list="form.applicantHistoricalMarriageFileGuidListPreview"
          style="flex:1;" :on-preview="handlePreview" :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'applicantHistoricalMarriageFileGuidList',true)"
          :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'applicantHistoricalMarriageFileGuidList',true)" :on-format-error="handleFormatError">
          <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
          <Button icon="ios-camera" @click.stop="openQrCodeUpload('applicantHistoricalMarriageFileGuidList',true)">手机拍照上传</Button>
        </Upload>
      </FormItem>
      <FormItem class="notice">
        <div>
          请完整提交每段婚姻材料：
          <div>1、离婚：离婚证、离婚协议书或法院调解书、判决书；</div>
          2、丧偶：死亡证明。
        </div>
        <div class="_linkdel" v-for="file in form.applicantHistoricalMarriageFileGuidListPreview" :key="file.guid">
          <div class="fileCentent" @click="handlePreview(file)">
            <Icon :type="file.name | fileType" />
            {{file.name?file.name:file.fileName}}
          </div>
          <div class="fileDel">
            <Icon type="md-close" @click="handleRemove(file, null, 'applicantHistoricalMarriageFileGuidList',true)" />
          </div>
        </div>
      </FormItem>
      </Col>
    </Row>
    <div class="bom_btn">
      <div>
        <Button @click="next(null,-1)">上一步</Button>
        <Button type="warning" @click="submitStore()">暂存</Button>
        <Button type="primary" @click="next('form'+current,(current_index+1))">下一步</Button>
      </div>
    </div>
  </Form>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },

  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: { readIdInfo: true },
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {
        idCardFrontGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        idCardBackGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        name: [{ required: true, message: '请输入', trigger: 'change' }],
        idCardNo: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请输入正确的身份证号',
            trigger: 'blur',
          },
        ],
        registeredResidenceType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        residenceBookletMainPageGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        residenceBookletSelfPageGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        applicantMarriageCertificateGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //上一步
      let _this = this

      if (name === null) {
        this.$emit('next', val)
        return
      }
      //下一步

      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        let formSubmit = true
        if (_this.form.applicantMaritalStatus === _this.$store.state.maritalStatusSet['离异']) {
          formSubmit = false
          //离婚证+离婚协议
          if (
            _this.form.applicantDivorceCertificateGuid &&
            Array.isArray(_this.form.applicantDivorceSettlementGuidList) &&
            _this.form.applicantDivorceSettlementGuidList.length > 0
          ) {
            formSubmit = true
          }
          //法院判决书
          if (
            Array.isArray(_this.form.applicantMarriageCourtJudgmentGuidList) &&
            _this.form.applicantMarriageCourtJudgmentGuidList.length > 0
          ) {
            formSubmit = true
          }
          //法院调解书
          if (
            Array.isArray(_this.form.applicantMarriageCourtMediationLetterGuidList) &&
            _this.form.applicantMarriageCourtMediationLetterGuidList.length > 0
          ) {
            formSubmit = true
          }
        }
        if (!formSubmit) {
          this.$Message.error({
            content: '离婚证与离婚协议、法院判决书、法院调解书必须上传一个',
            background: true,
            duration: 6,
          })
          return
        }
        let submiteUrl = '/api/services/app/JZZJFApi/SaveApplicantMarriageInfo'
        if (
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['初婚'] ||
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['再婚']
        ) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'], submiteUrl)
          return
        }
        if (_this.form.isChildrenEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['子女信息'], submiteUrl)
          return
        }
        if (!this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['加分材料'], submiteUrl)
          return
        }
        if (this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['学历信息'], submiteUrl)
          return
        }
      })
    },
    async submitStore() {
      await this.$emit(
        'submit',
        '/api/services/app/JZZJFApi/SaveApplicantMarriageInfo',
        0,
        '保存成功'
      )
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(
      response,
      file,
      fileList,
      property,
      isArray,
      isReadIdInfoAfter,
      readIdInfoAfterToView
    ) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadIdInfoAfter,
        readIdInfoAfterToView
      )
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    //
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>